export enum DynamicLoaderInlineAssets {
  Hotjar,
}
